module.exports = __webpack_public_path__ + "img/wallpaper-3.1be8c081.jpg";